export type AddressLike = {
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
} | null | undefined;

/** Single-line address for Settings / MetaRow display. */
export function formatAddress(address: AddressLike): string | null {
  if (!address) return null;
  const parts = [
    address.line1,
    address.line2,
    address.city,
    address.state,
    address.postalCode,
    address.country && address.country !== 'IN' ? address.country : null,
  ]
    .map((p) => (p != null ? String(p).trim() : ''))
    .filter(Boolean);
  return parts.length ? parts.join(', ') : null;
}

export type AddressFormValues = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
};

export const EMPTY_ADDRESS_FORM: AddressFormValues = {
  line1: '',
  line2: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'IN',
};

export function addressToForm(address: AddressLike): AddressFormValues {
  return {
    line1: address?.line1 ?? '',
    line2: address?.line2 ?? '',
    city: address?.city ?? '',
    state: address?.state ?? '',
    postalCode: address?.postalCode ?? '',
    country: address?.country || 'IN',
  };
}
